import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import ModalStore from '../../../stores/ModalStore'

const MyProfile = observer(
  ({ userId, userImageUri, userName, userLastRepostCreatedAt }) => {
    const navigate = useNavigate()
    const [animate, setAnimate] = useState(false)

    useEffect(() => {
      if (ModalStore?.currentFriendRepostFeed?.from === 'repostButton') {
        setAnimate(true)
        setTimeout(() => {
          ModalStore.setCurrentFriendRepostFeed({
            open: ModalStore?.currentFriendRepostFeed?.open,
            from: '',
          })
        }, 3000)
      } else {
        setAnimate(false)
      }
    }, [ModalStore?.currentFriendRepostFeed?.from])

    if (!userId) return null

    const onClick = () => {
      // 영상이 있든 없든 친구 페이지로 이동한다.
      if (userLastRepostCreatedAt) {
        navigate(`/reposts?reposterId=${userId}`)
      } else {
        ModalStore.setCurrentModal({ open: true, type: 'noRepost' })
      }
    }

    return (
      <div className='flex-start'>
        <button
          type='button'
          key={userId}
          className='flex flex-col items-center h-16 mx-0.5 w-16'
          onClick={onClick}
        >
          {animate ? (
            <motion.div
              animate={{ scale: [1, 1.2, 0.7, 1] }}
              transition={{ ease: 'easeInOut', duration: 1, delay: 1 }}
              className={`rounded-full p-[0.15rem] flex flex-col items-center justify-center ${
                userLastRepostCreatedAt
                  ? 'bg-gradient-to-r from-[#ff56d5] via-red-500 to-yellow-500'
                  : 'bg-[#858585]'
              }`}
            >
              <div className='w-11 h-11 rounded-full bg-[#2e2e2e] flex items-center justify-center'>
                <img
                  src={userImageUri}
                  alt='add-user '
                  className='flex items-center justify-center object-cover w-10 h-10 rounded-full'
                />
              </div>
            </motion.div>
          ) : (
            <div
              className={`rounded-full p-[0.15rem] flex flex-col items-center justify-center ${
                userLastRepostCreatedAt
                  ? 'bg-gradient-to-r from-[#ff56d5] via-red-500 to-yellow-500'
                  : 'bg-[#858585]'
              }`}
            >
              <div className='w-11 h-11 rounded-full bg-[#2e2e2e] flex items-center justify-center'>
                <img
                  src={userImageUri}
                  alt='add-user '
                  className='flex items-center justify-center object-cover w-10 h-10 rounded-full'
                />
              </div>
            </div>
          )}

          <div className='mt-1 text-xs text-white'>
            {userName.length > 5 ? `${userName.substr(0, 5)}...` : userName}
          </div>
        </button>
      </div>
    )
  },
)

export default MyProfile
